module.exports = __webpack_public_path__ + "media/images/lb/228-7c7892511ae60649c1dd05a15875d86b.svg";